import { useState, useEffect } from "react";
import { v4 as uuid } from "uuid";
import {
  Drawer,
  Button,
  Typography,
  Select as MTSelect,
  Option,
  Input,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  IconButton,
  Dialog,
  DialogBody,
  DialogHeader,
  Textarea,
} from "@material-tailwind/react";
import TextField from "@mui/material/TextField";
import Select from "react-select";
import Popup from "reactjs-popup";
import { toast } from "react-toastify";
import { HiArrowDownCircle } from "react-icons/hi2";
import { IoClose, IoCalendar, IoReload } from "react-icons/io5";
import { MdDeleteOutline } from "react-icons/md";
import Paper from "@mui/material/Paper";
import { DataGrid } from "@mui/x-data-grid";
import { awsBucketConfig } from "../../config/awsBucketConfig";

import {
  uploadLimits,
  wabaAcceptedInputTypes,
  updateDatabaseFields,
} from "../../config/appConfig.js";
import {
  uploadMediaOnAWS,
  EnumFileUploadStatus,
} from "../../helpers/AWSService.js";
import { useConversationContext } from "../../contexts/ConversationContextProvider";
import { useUserContext } from "../../contexts/UserContextProvider";
import {
  convertToUTC,
  convertTimeOnlyToUTC,
} from "../utils/timeStampConversion.js";
import { isoTimestampToLocal } from "../utils/timeStampConversion";
import { CustomLoader } from "..";
import { useWhatsappContext } from "../../contexts/WhatsappContextProvider";

const ManageAutoReplies = () => {
  const {
    createAutoReplyMessage,
    getAutoReplyMessages,
    removeAutoReplyMessage,
    toggleAutoReplyActive,
  } = useConversationContext();
  const { isLoading } = useUserContext();
  const { getWaTemplates, allTemplates } = useWhatsappContext();

  const blankMessage = {
    messageType: "text",
    bodyText: "",
    mediaValue: null,
  };
  const defaultInputValue = {
    minutes: "",
    hours: "",
    text: "",
    startDateTime: "",
    endDateTime: "",
    weekDay: [],
    startTime: "",
    endTime: "",
    triggerInHour: 24,
    templates: [],
  };

  const [autoRepliesMessageList, setAutoRepliesMessageList] = useState([]);
  const [listOfAutoReplies, setListOfAutoReplies] = useState([blankMessage]);
  const [toCreateAutoReplies, setToCreateAutoReplies] = useState(false);
  const [autoRepliesMessageBodyText, setAutoRepliesMessageBodyText] =
    useState("");
  const [mediaMessageCaption, setMediaMessageCaption] = useState("");
  const [triggerCondition, setTriggerCondition] = useState("");
  const [refreshPageCounter, setRefreshPageCounter] = useState(0);
  const [weekDayValue, setWeekDayValue] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [inputData, setInputData] = useState(defaultInputValue);
  const [openTriggerConditionPopup, setOpenTriggerConditionPopup] =
    useState(false);
  const [triggerConditionData, setTriggerConditionData] = useState(null);
  const [selectedFields, setSelectedFields] = useState([]);
  const [fieldValues, setFieldValues] = useState({});
  const [excelFileLink, setExcelFileLink] = useState("");
  const [enableTriggerActions, setEnableTriggerActions] = useState(false);
  const [filterTemplate, setFilterTemplate] = useState([]);

  // const [autoRepliesDelay, setAutoRepliesDelay] = useState("");

  const roles = ["Agent", "Admin", "SuperAdmin"];
  const channels = ["web", "whatsapp"];

  const [notifyPrefs, setNotifyPrefs] = useState({
    Agent: { web: false, whatsapp: false, type: 0 },
    Admin: { web: false, whatsapp: false, type: 1 },
    SuperAdmin: { web: false, whatsapp: false, type: 2 },
  });

  const toggleChannel = (role, channel) => {
    setNotifyPrefs((prev) => ({
      ...prev,
      [role]: {
        ...prev[role],
        [channel]: !prev[role][channel],
      },
    }));
  };

  const handleCheckboxChange = (dbField) => {
    setSelectedFields((prev) =>
      prev.includes(dbField)
        ? prev.filter((field) => field !== dbField)
        : [...prev, dbField]
    );
  };

  const handleValueOnChange = (dbField, value) => {
    setFieldValues((prev) => ({
      ...prev,
      [dbField]: value,
    }));
  };

  const weekDay = [
    {
      value: 0,
      label: "Sunday",
    },
    {
      value: 1,
      label: "Monday",
    },
    {
      value: 2,
      label: "Tuesday",
    },
    {
      value: 3,
      label: "Wednesday",
    },
    {
      value: 4,
      label: "Thursday",
    },
    {
      value: 5,
      label: "Friday",
    },
    {
      value: 6,
      label: "Saturday",
    },
  ];

  const autoRepliesTableColumns = [
    {
      field: "triggerConditionType",
      headerName: "Trigger Condition",
      width: 250,
      sortable: true,
      renderCell: (params) => (
        <div className="flex items-center gap-2">
          <span>{params.row?.triggerConditionType}</span>
          {(params.row?.triggerConditionType === "datetimeInBetween" ||
            params.row?.triggerConditionType === "daytimeInBetween") && (
            <IoCalendar
              onClick={(e) => {
                e.stopPropagation();
                setOpenTriggerConditionPopup(true);
                setTriggerConditionData({
                  type: params.row?.triggerConditionType,
                  startTime: params.row?.triggerCondition?.startTime,
                  endTime: params.row?.triggerCondition?.endTime,
                  triggerInHour: params.row?.triggerCondition?.triggerInHour,
                  weekDay: params.row?.triggerCondition?.weekDay
                    .map((day) => weekDay?.find((d) => d.value === day).label)
                    .join(", "),
                  startDateTime: params.row?.triggerCondition?.startDateTime,
                  endDateTime: params.row?.triggerCondition?.endDateTime,
                });
              }}
              className="text-green-600 cursor-pointer"
            />
          )}
        </div>
      ),
    },
    {
      field: "triggerText",
      headerName: "Trigger Text",
      width: 200,
      sortable: true,
      valueGetter: (value, row) => row?.triggerCondition?.text,
    },
    {
      field: "triggerFrequency",
      headerName: "Trigger Freq. (in hrs)",
      width: 200,
      sortable: true,
      valueGetter: (value, row) => row?.triggerCondition?.triggerInHour,
    },
    {
      field: "updatedContactFields",
      headerName: "Contact Fields Change",
      width: 300,
      sortable: false,
      renderCell: (params) => (
        <div className="space-y-1">
          {params.row?.updateDatabaseFields?.map((field, index) => (
            <div key={index} className="text-xs">
              <span className="font-medium">{field.fieldName}:</span>{" "}
              <span className="text-gray-600">
                {field.value === true
                  ? "Yes"
                  : field.value === false
                  ? "No"
                  : field.value || "-"}
              </span>
            </div>
          )) || <span className="text-gray-400">-</span>}
        </div>
      ),
    },
    {
      field: "messageType",
      headerName: "Reply Message Type",
      width: 200,
      sortable: true,
      valueGetter: (value, row) => row?.messageType,
    },
    {
      field: "replyMessage",
      headerName: "Reply Message",
      width: 500,
      sortable: false,
      renderCell: (params) => (
        <div className="flex items-center gap-2">
          {params.row?.messageType !== "text" ? (
            <>
              <pre className="whitespace-break-spaces text-sm mr-2">
                {params.row?.replyText || params.row?.mediaCaption}
              </pre>
              <button
                onClick={(e) => {
                  const url =
                    awsBucketConfig.openUploadedFilePrefix +
                    params?.row?.replyText;
                  window.open(url, "_blank", "noopener,noreferrer");
                }}
                className="wbm-cta-btn-2"
                variant="outlined"
              >
                View
              </button>
            </>
          ) : (
            <pre className="whitespace-break-spaces text-sm">
              {params.row?.replyText || params.row?.mediaCaption}
            </pre>
          )}
        </div>
      ),
    },
    {
      field: "isActive",
      headerName: "Activate",
      width: 100,
      sortable: true,
      renderCell: (params) => (
        <input
          type="checkbox"
          role="switch"
          onChange={() =>
            handleAutoReplyActiveToggle(params.row?._id, !params.row?.isActive)
          }
          checked={params.row?.isActive}
          className={`my-toggle-switch disabled:bg-gray-400`}
        />
      ),
    },
    {
      field: "options",
      headerName: "",
      width: 150,
      sortable: true,
      renderCell: (params) => (
        <div className="flex gap-3 w-96">
          <Menu>
            <MenuHandler>
              <IconButton variant="text">
                <HiArrowDownCircle className="h-7 w-7" />
              </IconButton>
            </MenuHandler>
            <MenuList>
              <MenuItem>
                <Popup
                  trigger={
                    <Button color="red" size="sm" className="w-36">
                      Delete Message
                    </Button>
                  }
                  position="left bottom"
                  className="hidden"
                >
                  <div className="my-popup-style-1">
                    <p>
                      Are you sure you want to delete "{params.row?.messageType}
                      "?
                    </p>
                    <button
                      type="button"
                      onClick={() => handleDeleteOnClick(params.row?._id)}
                      className="my-button-style-cancel mt-2 flex items-center gap-1 text-sm"
                    >
                      <MdDeleteOutline size="0.8rem" />
                      Delete Message
                    </button>
                  </div>
                </Popup>
              </MenuItem>
            </MenuList>
          </Menu>
        </div>
      ),
    },
  ];

  const handleSelectOnChange = (index, newMessageType) => {
    const updatedMessages = listOfAutoReplies?.map((item, i) =>
      i === index
        ? {
            ...item,
            messageType: newMessageType,
            bodyText: "",
            mediaValue: null,
          }
        : item
    );
    setListOfAutoReplies(updatedMessages);
  };

  const handleInputOnChange = (index, e, type) => {
    let value;
    if (type === "bodyText") {
      value = e.target.value;
      setAutoRepliesMessageBodyText(value);
    } else if (type === "mediaValue") {
      value = e.target?.files?.[0];
      setAutoRepliesMessageBodyText(value?.fileName);
    }

    let updatedMessages = listOfAutoReplies?.map((item, i) =>
      i === index ? { ...item, [type]: value } : item
    );

    setListOfAutoReplies(updatedMessages);
  };

  const handleTriggerConditionChange = (e) => {
    setInputData(defaultInputValue);
    setTriggerCondition(e);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleCaptionOnChange = (e) => {
    const { value } = e.target;
    setMediaMessageCaption(value);
  };

  const handleAutoRepliesMessageOnSubmit = async (e) => {
    e.preventDefault();

    let hasBlankBodyText = false;
    let autoRepliesMessages = {};

    for (let i = 0; i < listOfAutoReplies.length; i++) {
      const message = listOfAutoReplies[i];

      if (message?.messageType !== "text" && message?.mediaValue) {
        const file = message.mediaValue;
        const fileName = await uploadMedia(file);
        autoRepliesMessages = {
          messageType: message.messageType,
          bodyText: fileName,
        };
      } else {
        if (!message.bodyText || message.bodyText.trim() === "") {
          toast.error(`Auto reply message is required`);
          hasBlankBodyText = true;
          return;
        } else {
          autoRepliesMessages = {
            messageType: message.messageType,
            bodyText: message.bodyText.trim(),
          };
        }
      }

      if (!hasBlankBodyText && i === listOfAutoReplies.length - 1) {
        autoRepliesMessages.triggerConditionType = triggerCondition;
        const convertIfNotEmpty = (date) => {
          return date !== "" ? convertToUTC(date) : date;
        };

        const convertIfNotEmptyTime = (time) => {
          return time !== "" ? convertTimeOnlyToUTC(time) : time;
        };

        inputData.startDateTime = convertIfNotEmpty(inputData?.startDateTime);
        inputData.endDateTime = convertIfNotEmpty(inputData?.endDateTime);
        inputData.startTime = convertIfNotEmptyTime(inputData?.startTime);
        inputData.endTime = convertIfNotEmptyTime(inputData?.endTime);
        inputData.templates = selectedTemplate
          ? selectedTemplate.map((template) => template.value)
          : [];

        if (weekDayValue && weekDayValue.length > 0) {
          weekDayValue?.map((key) => inputData.weekDay.push(key.value));
        }

        autoRepliesMessages.triggerCondition = inputData;
        autoRepliesMessages.triggerCondition.text =
          autoRepliesMessages.triggerCondition.text.trim();
        if (autoRepliesMessages?.messageType !== "text") {
          autoRepliesMessages.mediaCaption = mediaMessageCaption;
        } else {
          autoRepliesMessages.mediaCaption = "";
        }

        const result = updateDatabaseFields
          .filter((field) => selectedFields.includes(field.dbField))
          .map((field) => ({
            fieldName: field.fieldName,
            dbField: field.dbField,
            value:
              field.type === "Boolean"
                ? fieldValues[field.dbField] === "1"
                : fieldValues[field.dbField] || "",
          }));
        autoRepliesMessages.updateDatabaseFields = result;

        const filteredPrefs = Object.fromEntries(
          Object.entries(notifyPrefs).filter(
            ([_, prefs]) => prefs.web || prefs.whatsapp
          )
        );
        autoRepliesMessages.notifyUsers = filteredPrefs;
        autoRepliesMessages.googleSheetId = excelFileLink;

        const res = await createAutoReplyMessage(autoRepliesMessages);
        if (res?.message || res?.Error) {
          setRefreshPageCounter((prvCounter) => prvCounter + 1);
          resetStates();
        }
      }
    }
  };

  const uploadMedia = async (uploadedFile) => {
    try {
      const uniqueId = uuid();
      const uniqueFileName =
        uniqueId + "." + uploadedFile?.name.split(".").pop().toLowerCase();
      const uploadParams = {
        fileName: uniqueFileName,
        mediaFile: uploadedFile,
        fileType: uploadedFile?.type,
      };

      const response = await uploadMediaOnAWS(uploadParams);
      if (response === EnumFileUploadStatus.FileUploadSuccess) {
        return uniqueFileName;
      } else {
        return "";
      }
    } catch (err) {
      console.log("autoReplyMessages uploadMedia err", err);
      return "";
    }
  };

  const loadAutoRepliesMessagesOnClick = async () => {
    const response = await getAutoReplyMessages();
    setAutoRepliesMessageList(response);
  };

  const handleAutoReplyActiveToggle = async (messageId, isActive) => {
    await toggleAutoReplyActive(messageId, isActive);
    setRefreshPageCounter((prvCounter) => prvCounter + 1);
  };

  const handleDeleteOnClick = async (messageId) => {
    await removeAutoReplyMessage(messageId);
    setRefreshPageCounter((prvCounter) => prvCounter + 1);
  };

  const handleScrollOnScroll = (e) => {
    // Prevent scrolling from bubbling up to parent elements
    e.stopPropagation();
  };

  const resetStates = () => {
    setToCreateAutoReplies(false);
    setAutoRepliesMessageBodyText("");
    setMediaMessageCaption("");
    setTriggerCondition("");
    setListOfAutoReplies([blankMessage]);
    setWeekDayValue(null);
    setInputData(defaultInputValue);
    setTriggerConditionData(null);
    setFieldValues({});
    setExcelFileLink("");
  };

  useEffect(() => {
    const loadTemplate = async () => {
      const templatesData = await getWaTemplates();
      const mapTemplate = templatesData.map((template) => ({
        value: template.name,
        label: template.name,
      }));
      setFilterTemplate(mapTemplate);
    };
    loadTemplate();
  }, []);

  useEffect(() => {
    loadAutoRepliesMessagesOnClick();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshPageCounter]);

  const renderInputs = () => {
    switch (triggerCondition) {
      case "datetimeInBetween":
        return (
          <div className="space-y-2">
            <div className="flex flex-row gap-2">
              <Input
                variant="outlined"
                color="green"
                type="datetime-local"
                name="startDateTime"
                containerProps={{
                  className: "min-w-0",
                }}
                value={inputData.startDateTime}
                onChange={handleInputChange}
              />
            </div>
            <div className="flex flex-row gap-2">
              <Input
                variant="outlined"
                color="green"
                type="datetime-local"
                name="endDateTime"
                containerProps={{
                  className: "min-w-0",
                }}
                value={inputData.endDateTime}
                onChange={handleInputChange}
              />
            </div>
            <Input
              variant="outlined"
              color="green"
              type="number"
              name="triggerInHour"
              label="Repeat this auto reply in x hours"
              value={inputData.triggerInHour}
              onChange={handleInputChange}
              className="w-[100%]"
            />
          </div>
        );
      case "daytimeInBetween":
        return (
          <div className="space-y-2">
            <div className="w-full">
              <Select
                className="mb-4"
                value={weekDayValue}
                placeholder="Select week day"
                defaultValue={weekDayValue}
                closeMenuOnSelect={false}
                onChange={setWeekDayValue}
                isMulti="true"
                options={weekDay}
              />
            </div>
            <div className="flex flex-row gap-2 mb-3">
              <Input
                variant="outlined"
                color="green"
                type="time"
                containerProps={{
                  className: "custom-width-auto",
                }}
                name="startTime"
                value={inputData.startTime}
                onChange={handleInputChange}
              />
              <Input
                variant="outlined"
                color="green"
                type="time"
                name="endTime"
                containerProps={{
                  className: "custom-width-auto",
                }}
                value={inputData.endTime}
                onChange={handleInputChange}
              />
            </div>
            <Input
              variant="outlined"
              color="green"
              type="number"
              name="triggerInHour"
              label="Repeat this auto reply in x hours"
              value={inputData.triggerInHour}
              onChange={handleInputChange}
              className="w-[100%]"
            />
          </div>
        );
      case "buttonReply":
        return (
          <div className="flex flex-col justify-start gap-2 w-full">
            <TextField
              id="button text"
              label="Enter button text"
              value={inputData.text}
              name="text"
              onChange={handleInputChange}
              placeholder="Enter button text which should be received to trigger auto-reply"
              required
              variant="standard"
              className="w-full"
            />
            <div className="w-full">
              <Select
                value={selectedTemplate}
                placeholder="Select template if button needs to be triggered selectively"
                defaultValue={selectedTemplate}
                closeMenuOnSelect={false}
                onChange={setSelectedTemplate}
                isMulti="true"
                options={filterTemplate}
                className="mb-4 z-20"
              />
            </div>
          </div>
        );
      case "exactText":
        return (
          <Input
            variant="standard"
            color="green"
            type="text"
            name="text"
            label="Enter exact text"
            placeholder="Enter exact text which should be received to trigger auto-reply"
            required
            value={inputData.text}
            onChange={handleInputChange}
          />
        );
      case "containsText":
        return (
          <Input
            variant="standard"
            color="green"
            type="text"
            name="text"
            label="Enter contains text"
            placeholder="Enter contains text which should be received to trigger auto-reply"
            required
            value={inputData.text}
            onChange={handleInputChange}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      {isLoading && <CustomLoader />}
      <main className="w-full mt-5 mb-10 lg:my-1 space-y-5">
        <div className="w-full space-y-2">
          <h1 className="text-2xl">Manage Auto Replies</h1>
          <h3>Create, Delete and Manage Auto Replies messages.</h3>
        </div>
        <div className="flex gap-3">
          <Button
            type="button"
            variant="gradient"
            color="blue"
            onClick={() => {
              setEnableTriggerActions(false);
              setSelectedFields([]);
              setListOfAutoReplies([blankMessage]);
              setWeekDayValue(null);
              setTriggerCondition("");
              setInputData(defaultInputValue);
              setToCreateAutoReplies(true);
            }}
          >
            Create Auto Replies
          </Button>
          <button
            onClick={() => loadAutoRepliesMessagesOnClick()}
            className="my-button-style-5"
          >
            <IoReload size={24} />
          </button>
        </div>
        <Paper style={{ position: "relative", zIndex: 1, height: 550 }}>
          <DataGrid
            getRowId={(row) => row?._id}
            rows={autoRepliesMessageList}
            columns={autoRepliesTableColumns}
            initialState={{
              pagination: { paginationModel: { pageSize: 100 } },
            }}
            sx={{
              border: 0,
              "& .MuiDataGrid-columnHeaders": {
                position: "sticky",
                top: 0,
                zIndex: 1,
                backgroundColor: "background.paper",
              },
              "& .MuiDataGrid-virtualScroller": {
                marginTop: "0px",
              },
            }}
            getRowClassName={() => "cursor-pointer"}
            disableColumnMenu={false}
            disableRowSelectionOnClick={true}
          />
        </Paper>
      </main>

      <Drawer
        placement="right"
        onScroll={handleScrollOnScroll}
        open={toCreateAutoReplies}
        size="650px"
        className="w-full p-5 overflow-y-scroll"
      >
        <form onSubmit={handleAutoRepliesMessageOnSubmit} className="space-y-3">
          <div className="flex justify-center flex-row">
            <Typography
              variant="h4"
              color="blue"
              className="text-center items-center"
            >
              Create Auto Reply
            </Typography>
            <button
              type="button"
              onClick={() => resetStates()}
              className="my-button-style-cancel absolute top-5 right-5 items-end"
            >
              <IoClose size={18} />
            </button>
          </div>

          {listOfAutoReplies?.map((item, index) => (
            <div key={index} className="w-full mt-3 space-y-5">
              <MTSelect
                variant="standard"
                color="blue"
                required
                label="Message Type"
                value={item?.messageType}
                onChange={(e) => handleSelectOnChange(index, e)}
                className="my-input-box-1"
              >
                <Option
                  key="text"
                  value="text"
                  className={`hover:bg-blue-300 focus:bg-blue-300`}
                >
                  Text
                </Option>
                <Option
                  key="image"
                  value="image"
                  className={`hover:bg-blue-300 focus:bg-blue-300`}
                >
                  Image
                </Option>
                <Option
                  key="video"
                  value="video"
                  className={`hover:bg-blue-300 focus:bg-blue-300`}
                >
                  Video
                </Option>
                <Option
                  key="audio"
                  value="audio"
                  className={`hover:bg-blue-300 focus:bg-blue-300`}
                >
                  Audio
                </Option>
              </MTSelect>

              {item?.messageType !== "text" ? (
                <div className="flex flex-col justify-start gap-2">
                  <Input
                    type="file"
                    variant="standard"
                    color="blue"
                    label="Auto Reply Media"
                    labelProps={{
                      className: "text-slate-800",
                    }}
                    accept={
                      item?.messageType === "image"
                        ? wabaAcceptedInputTypes.image
                        : item?.messageType === "video"
                        ? wabaAcceptedInputTypes.video
                        : item?.messageType === "audio"
                        ? wabaAcceptedInputTypes.audio
                        : wabaAcceptedInputTypes.document
                    }
                    max={
                      item?.messageType === "image"
                        ? uploadLimits.image
                        : item?.messageType === "video"
                        ? uploadLimits.video
                        : item?.messageType === "audio"
                        ? uploadLimits.audio
                        : uploadLimits.document
                    }
                    required
                    value={autoRepliesMessageBodyText}
                    autoComplete="off"
                    onChange={(e) =>
                      handleInputOnChange(index, e, "mediaValue")
                    }
                  />
                  <Input
                    variant="standard"
                    label="Type Caption"
                    resize={true}
                    autoComplete="off"
                    value={mediaMessageCaption}
                    onChange={handleCaptionOnChange}
                  />
                </div>
              ) : (
                <Textarea
                  variant="standard"
                  label="Type the message you want to send when this condition is triggered"
                  resize={true}
                  autoComplete="off"
                  value={autoRepliesMessageBodyText}
                  required
                  onChange={(e) => handleInputOnChange(index, e, "bodyText")}
                />
              )}
            </div>
          ))}
          <div className="pt-5 space-y-2">
            <MTSelect
              variant="standard"
              color="blue"
              required
              label="Trigger Conditions"
              value={triggerCondition}
              onChange={handleTriggerConditionChange}
              className="my-input-box-1"
            >
              <Option value="">~ Choose a Trigger Condition ~</Option>
              <Option
                className={`hover:bg-blue-300 focus:bg-blue-300`}
                value="buttonReply"
                key="buttonReply"
              >
                Button Reply
              </Option>
              <Option
                className={`hover:bg-blue-300 focus:bg-blue-300`}
                value="exactText"
                key="exactText"
              >
                Exact Text
              </Option>
              <Option
                className={`hover:bg-blue-300 focus:bg-blue-300`}
                value="containsText"
                key="containsText"
              >
                Contains Text
              </Option>
              <Option
                className={`hover:bg-blue-300 focus:bg-blue-300`}
                value="datetimeInBetween"
                key="datetimeInBetween"
              >
                Date Time in Between
              </Option>
              <Option
                className={`hover:bg-blue-300 focus:bg-blue-300`}
                value="daytimeInBetween"
                key="daytimeInBetween"
              >
                Day Time in Between
              </Option>
            </MTSelect>
            <div className="mt-3 mb-2">{renderInputs()}</div>
          </div>

          <div className="pt-3 space-y-3">
            <p className="">Enable Actions (optional)</p>
            <input
              type="checkbox"
              role="switch"
              onChange={() => setEnableTriggerActions(!enableTriggerActions)}
              checked={enableTriggerActions}
              className={`my-toggle-switch`}
            />
          </div>

          {enableTriggerActions && (
            <div className="space-y-5">
              <h4 className="wabm-font-style-2 text-lg">Actions</h4>
              <div className="space-y-3">
                <div>Update a contact field</div>
                <table className="w-full table-auto">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="p-2 border w-12">Select</th>
                      <th className="p-2 border w-36">Field Name</th>
                      <th className="p-2 border">Input</th>
                    </tr>
                  </thead>
                  <tbody>
                    {updateDatabaseFields?.map((field) => (
                      <tr key={field.dbField} className="">
                        <td className="p-2 border">
                          <input
                            type="checkbox"
                            checked={selectedFields.includes(field.dbField)}
                            onChange={() => handleCheckboxChange(field.dbField)}
                            className="h-4 w-4 text-blue-600"
                          />
                        </td>
                        <td className="p-2 border">{field.fieldName}</td>
                        <td className="p-2 border">
                          {selectedFields.includes(field.dbField) &&
                            (field.type === "Boolean" ? (
                              <select
                                value={fieldValues[field.dbField] || ""}
                                onChange={(e) =>
                                  handleValueOnChange(
                                    field.dbField,
                                    e.target.value
                                  )
                                }
                                className="border rounded p-1 w-full"
                              >
                                <option value="" hidden ng-disabled="!!model">
                                  ~ Select ~
                                </option>
                                <option value="1">Yes</option>
                                <option value="0">No</option>
                              </select>
                            ) : (
                              <Input
                                variant="standard"
                                label={`Enter ${field.fieldName}`}
                                resize={true}
                                autoComplete="off"
                                value={fieldValues[field.dbField] || ""}
                                onChange={(e) =>
                                  handleValueOnChange(
                                    field.dbField,
                                    e.target.value
                                  )
                                }
                              />
                            ))}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="space-y-3">
                <div>Notify Users</div>
                <table className="w-full table-auto">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="p-2 border">Role</th>
                      <th className="p-2 border">Notify on Email</th>
                      <th className="p-2 border">Notify on WhatsApp</th>
                    </tr>
                  </thead>
                  <tbody>
                    {roles.map((role) => (
                      <tr key={role} className="">
                        <td className="p-2 border font-medium">{role}</td>
                        {channels.map((channel) => (
                          <td className="p-2 border" key={channel}>
                            <input
                              type="checkbox"
                              checked={notifyPrefs[role][channel]}
                              onChange={() => toggleChannel(role, channel)}
                              className="h-4 w-4 text-blue-600"
                            />
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <Input
                variant="standard"
                label="Google Sheet ID"
                name="excelFileLink"
                resize={true}
                autoComplete="off"
                value={excelFileLink}
                onChange={(e) => {
                  setExcelFileLink(e.target.value);
                }}
              />
            </div>
          )}

          <div>
            <div className="my-horizontal-line" />
          </div>

          <Button variant="gradient" color="blue" type="submit">
            Create Auto Reply
          </Button>
        </form>
      </Drawer>

      {openTriggerConditionPopup && (
        <Dialog
          open={openTriggerConditionPopup}
          handler={() =>
            setOpenTriggerConditionPopup(!openTriggerConditionPopup)
          }
        >
          <DialogHeader
            color="green"
            iconOnly
            onClose={() => setOpenTriggerConditionPopup(false)}
          >
            <div className="text-green-700 text-2xl font-bold">
              Trigger Conditions Details
            </div>
          </DialogHeader>
          <DialogBody>
            <div className="flex flex-col border p-3 rounded-md border-gray-300">
              {triggerConditionData?.type === "daytimeInBetween" && (
                <div className="flex flex-col gap-3">
                  <div className="flex flex-row gap-3">
                    <span className="font-semibold">Start Time</span>
                    <span>
                      {triggerConditionData?.startTime} <bold>UTC</bold>
                    </span>
                  </div>
                  <div className="flex flex-row gap-3">
                    <span className="font-semibold">End Time</span>
                    <span>
                      {triggerConditionData?.endTime} <bold>UTC</bold>
                    </span>
                  </div>
                  <div className="flex flex-row gap-3">
                    <span className="font-semibold">
                      Repeat this auto reply in (Hour)
                    </span>
                    <span>{triggerConditionData?.triggerInHour}</span>
                  </div>
                  <div className="flex flex-row gap-3">
                    <span className="font-semibold">Week Day</span>
                    <span>{triggerConditionData?.weekDay}</span>
                  </div>
                </div>
              )}
              {triggerConditionData?.type === "datetimeInBetween" && (
                <div className="flex flex-col gap-3">
                  <div className="flex flex-row gap-3">
                    <span className="font-semibold">Start Date Time</span>
                    <span>
                      {isoTimestampToLocal(triggerConditionData?.startDateTime)}
                    </span>
                  </div>
                  <div className="flex flex-row gap-3">
                    <span className="font-semibold">End Date Time</span>
                    <span>
                      {isoTimestampToLocal(triggerConditionData?.endDateTime)}
                    </span>
                  </div>
                  <div className="flex flex-row gap-3">
                    <span className="font-semibold">
                      Repeat this auto reply in (Hour)
                    </span>
                    <span>{triggerConditionData?.triggerInHour}</span>
                  </div>
                </div>
              )}
            </div>
          </DialogBody>
        </Dialog>
      )}
    </>
  );
};

export default ManageAutoReplies;
